import { Controller } from '@hotwired/stimulus'
import { enter, leave } from 'el-transition'

export default class extends Controller {
  static targets = ['charge', 'onPageFilter', 'onPageFilterClear']

  chargeTargetConnected(charge) {
    if (this.currentFilter) {
      this.#filter(this.currentFilter)
    }
  }

  clearFilter() {
    this.currentFilter = undefined
    if (this.hasOnPageFilterTarget) {
      this.onPageFilterTarget.dispatchEvent(
        new CustomEvent('on-page-filter:enable', { bubbles: true })
      )
    }
    this.chargeTargets.forEach(charge => enter(charge))
  }

  filterCharges(event) {
    const fieldSettingId = Number(event.target.value)

    if (fieldSettingId && !isNaN(fieldSettingId)) {
      if (this.hasOnPageFilterTarget && this.currentFilter === undefined) {
        this.onPageFilterTarget.dispatchEvent(
          new CustomEvent('on-page-filter:disable', { bubbles: true })
        )
      }

      this.currentFilter = fieldSettingId
      this.#filter(fieldSettingId)
    }
  }

  onPageFilterTargetConnected(filter) {
    if (this.currentFilter) {
      filter.dispatchEvent(
        new CustomEvent('on-page-filter:disable', { bubbles: true })
      )
    }
  }

  #filter(fieldSettingId) {
    this.chargeTargets.forEach((charge) => {
      const fieldSettingIds = JSON.parse(charge.dataset.fieldSettingIds) || []
      if (fieldSettingIds.includes(fieldSettingId)) {
        enter(charge)
      } else {
        leave(charge)
      }
    })
  }
}
